module.exports = __webpack_public_path__ + "img/chapter-3-thumb.fbf0c32c.jpg";